import type { Address } from '../types/dashboard';
import moment from 'moment';
import { tz } from 'moment-timezone';
import { IUserData } from '../types/userdata';
import { userBasicData } from '../types/basicdata';
import ReactGA from "react-ga4";
import { MyCredentials } from '../types/allcredential';
import { saveAs } from 'file-saver';
import ExcelJS from "exceljs";
import { messageMap } from '../utils/messageMap';
import { BulkUpdate } from '../types/bulkUpdate';



var contactId;
var tokenId;

export function setTokenId(_tokenId) {
  tokenId = _tokenId;
}
export enum StatusReason {
  Pending = "Pending",
  PendingAudit = "PendingAudit",
  Inactive = "Inactive",
  PendingCertification = "PendingCertification",
  Approved = "Approved",
  Expired = "Expired",
  HOLD = "HOLD",
  Retired = "Retired",
  PendingRenewal = "PendingRenewal"

}
export enum OptionSet {
  Employer = 692260000,
  Union = 692260001,
  TrainingProvider = 692260002,
  InsuranceProvider = 692260003,
  RegulatoryBody = 692260004,
  Other = 692260005,
}


export function getOrgTypeEnum(value: string): OptionSet {
  switch (value) {
    case 'Employer':
      return OptionSet.Employer;
    case 'Union':
      return OptionSet.Union;
    case 'TrainingProvider':
      return OptionSet.TrainingProvider;
    case 'InsuranceProvider':
      return OptionSet.InsuranceProvider;
    case 'RegulatoryBody':
      return OptionSet.RegulatoryBody;
    case 'Other':
      return OptionSet.Other;
    default:
      return null;
  }
}



export function setUserData(payload) {
  const data: IUserData = {
    accessToken: payload.accessToken,
    tokenExpiry: payload.expiresOn,
    contactId: payload.idTokenClaims.extension_ContactId
  }
  setTokenId(data.accessToken);
  setContactId(data.contactId);
  const stringObject = JSON.stringify(data);
  localStorage.setItem('msal.userData', stringObject);
}

export function getUserData() {
  const data = localStorage.getItem('msal.userData');
  return JSON.parse(data) as IUserData;
}

// export function getTokens() {
//     const keylist = localStorage.getItem('msal.token.keys.'+REACT_APP_CLIENT_ID);
//     const parced=JSON.parse(keylist);
//     const accessToken = localStorage.getItem(parced);
//     return JSON.parse(data) as IUserData;
// }

export function setContactId(_contactId) {
  // localStorage.setItem('contactId',_contactId);
  contactId = _contactId;
}
export function getToken() {
  const data = getUserData().accessToken;
  return data ? data : tokenId
}

export function getContactId() {
  const data = getUserData();
  return data ? data.contactId : null;
}

const {
  REACT_APP_Computer_Based_Testing_URL,
  REACT_APP_Online_Written_Testing_URL,
  REACT_APP_Paper_Pencil_Testing_URL,
  REACT_APP_Practical_Testing_URL,
  REACT_APP_Test_Administrations_URL,
} = process.env;
export const formatAddress = (address: Address) => {
  if (!address.Street1 || !address.City || !address.Zip) {
    return null;
  }

  return (
    (address.Street1 ? address.Street1 + ', ' : '') +
    (address.Street2 ? address.Street2 + ', ' : '') +
    (address.City ? address.City + ', ' : '') +
    (address.State ? address.State + ', ' : '') +
    (address.Zip ? address.Zip : '')
  );
};

export const NullBadgeUrl = 'https://ncccoimages.blob.core.windows.net/%24web/mycco/credentialbadges/Null%20Badge.png';
export const allowedFileTypes = ['image/jpeg', 'image/png', 'application/pdf'];
export const notAllowedButtons = ['EOT Coordinator Core', 'Practical Coordinator Core', 'MBL Workshop', 'Telehandler Workshop']
export type DateFormats = 'MMDDYY' | 'DDMMYY' | 'YYYYMMDD' | 'DD MMM YY' | 'YY-MM-DD' | 'YYYY-MM-DD' | 'DD-MM-YY' | 'YY-MM-DD HH:mm' | 'YYYY-MM-DD HH:mm' | 'DD-MM-YY HH:mm' | 'HH:mm:ss' | 'HH:mm A' | 'ddd YY' | 'ddd YYYY' | 'DD MMM YYYY' | 'DD MMM YYYY HH:mm' | 'YYYY-MM-DD HH:mm:ss' | 'MM-DD-YY HH:mm:ss' | 'MMMM DD, YYYY' | 'DD MMMM YYYY' | 'DD MMMM YYYY HH:mm' | 'YY MMM DD' | 'YYYY MMMM DD' | 'YY MMM DD HH:mm' | 'HH:mm A ddd DD MMM YY' | 'DD MMM YY HH:mm A' | 'DD-MM-YY HH:mm A' | 'DD MMM YY HH:mm A' | 'YYYY MMMM DD HH:mm A' | 'DD-MM-YY HH:mm A ddd' | 'DD MMMM YYYY HH:mm A' | 'YY-MM-DD HH:mm A ddd' | 'YYYY MMMM DD HH:mm A ddd' | 'DD MMM YY HH:mm A ddd' | 'HH:mm:ss A' | 'HH:mm:ss A ddd DD MMM YY' | 'DD MMM YY HH:mm:ss' | 'YY-MM-DD HH:mm:ss' | 'YYYY-MM-DD HH:mm:ss A' | 'YY MMM DD HH:mm:ss A' | 'YYYY MMMM DD HH:mm:ss A' | 'DD MMM YY HH:mm:ss A' | 'DD MMMM YYYY HH:mm:ss A';

export const customURLs =
{
  "registerUrl": "https://NCCCOB2CDev.b2clogin.com/NCCCOB2CDev.onmicrosoft.com/oauth2/v2.0/authorize?p=B2C_1_SignUp_TEST&client_id=64f8f40b-475d-4d43-9d0c-8a61a2da18bf&nonce=defaultNonce&redirect_uri=https%3A%2F%2Fportal-test.nccco.org%2F&scope=openid&response_type=id_token&prompt=login",
  "onlineWrittenTestingUrl": {
    "button_text": "Written Testing",
    "button_url": REACT_APP_Online_Written_Testing_URL
  },
  "practicalTestingUrl": {
    "button_text": "Practical Testing",
    "button_url": REACT_APP_Practical_Testing_URL
  },
  "computerBasedTestingUrl": {
    "button_text": "Written Testing - CBT (PSI Test Centers)",
    "button_url": REACT_APP_Computer_Based_Testing_URL
  },
  "paperPencilTestingUrl": {
    "button_text": "Written Testing - PPT",
    "button_url": REACT_APP_Paper_Pencil_Testing_URL
  },
  "esoCandidateDashboardUrl": {
    "button_text": "Launch myCCO Exam Hub",
    "button_url": "https://qa7portal.examstudio.com/sso/oidc.aspx"
  },
  "manageMyTestAdministrationsUrl": {
    "button_text": "Manage My Test Administrations",
    "button_url": REACT_APP_Test_Administrations_URL
  }
}

export const utcToLocalDateTime = (datetime: string) => {
  if (!datetime) {
    return '';
  }
  let timezone = tz.guess(true);
  let tzAbbr = moment.tz(timezone).format('z');
  return moment.utc(datetime).local().format('MM-DD-YYYY hh:mmA') + " (" + tzAbbr + ")";

};

export const isTokenExpired = (tokenExpiry: string) => {
  const currentTimestamp = Date.now();
  return currentTimestamp >= (parseInt(tokenExpiry) * 1000);
}

export const getExtByMimeType = (mimeType: string) => {
  switch (mimeType) {
    case 'image/png':
      return 'png';
    case 'image/jpeg':
      return 'jpg';
    case 'image/gif':
      return 'gif';
    // Add more cases for other MIME types as needed
    default:
      return 'unknown';
  }
}
export const showCardBorder = (expDate: string, setShowcardBorder: any) => {
  const expirationDate = moment(expDate);
  const currentDate = moment();
  const sixtyDaysBefore = expirationDate.clone().subtract(60, 'days');
  const oneEightyDaysAfter = expirationDate.clone().add(180, 'days');
  const isShowBorder = currentDate.isBetween(sixtyDaysBefore, oneEightyDaysAfter, null, '[]');
  if (isShowBorder) {
    setShowcardBorder(true);
  } else {
    setShowcardBorder(false);
  }
}
export const showContactCredentialCardBorder = (expDate: string, setShowcardBorder: any) => {
  if (expDate) {
    const expirationDate = moment(expDate);
    const currentDate = moment();
    const sixtyDaysBefore = expirationDate.clone().subtract(60, 'days');
    const isTodayExpiryDate = currentDate.isSame(expirationDate, 'day');
    const isExpiryWithinSixtyDays = currentDate.isBefore(expirationDate) && currentDate.isSameOrAfter(sixtyDaysBefore, 'day');

    if (isTodayExpiryDate || isExpiryWithinSixtyDays) {
      setShowcardBorder(true);
      return true;
    } else {
      setShowcardBorder(false);
      return false;
    }
  }

}

export const isWithinSixtyDays = (expDate: string): boolean => {
  if (!expDate || expDate === '0001-01-01T00:00:00') return false;

  const expirationDate = moment(expDate);
  const currentDate = moment();
  const sixtyDaysBefore = expirationDate.clone().subtract(60, 'days');

  const isToday = currentDate.isSame(expirationDate, 'day');
  const isInRange = currentDate.isBefore(expirationDate) && currentDate.isSameOrAfter(sixtyDaysBefore, 'day');

  return isToday || isInRange;
};

export const sortByExpiryDate = (
  credentials: MyCredentials[]) => {
  return credentials.sort((a, b) => {
    const dateA = new Date(a.EarnedCredential.ExpiryDate).getTime();
    const dateB = new Date(b.EarnedCredential.ExpiryDate).getTime();

    const isInvalidA = dateA <= new Date('1900-01-01').getTime();
    const isInvalidB = dateB <= new Date('1900-01-01').getTime();

    if (isInvalidA && !isInvalidB) return 1;
    if (!isInvalidA && isInvalidB) return -1;

    return dateA - dateB;
  });
};

export const getUserBasicData = () => {
  const token = getToken();
  if (token) {
    const parsed = JSON.parse(decodeURIComponent(escape(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/').padEnd((token.split('.')[1].length + 3) & ~3, '=')))));

    const userData: userBasicData = {
      CandidateId: parsed.extension_CandidateId || '',
      Email: parsed.emails[0] || '',
      FullName: parsed.name || '',
      First: parsed.given_name,
      Last: parsed.family_name

    };

    return userData;
  } else {
    const userData: userBasicData = {
      CandidateId: '',
      Email: '',
      FullName: '',
      First: '',
      Last: ''
    };
    return userData;
  }
};


export const getDate = (format: DateFormats) => {
  const formattedDate = moment().format(format);
  return formattedDate;
}

export const handleCertificationShareButtonClick = () => {
  ReactGA.event({
    category: "CertificationShareButton",
    action: "Certification Share Button Clicked",
    label: "Certification Share Button",
    value: 1, // Optional numeric value
    nonInteraction: false, // Ensures it counts as an interaction
  });
};
export const handleCredentialShareButtonClick = () => {
  ReactGA.event({
    category: "CredentialShareButton",
    action: "Credential Share Button Clicked",
    label: "Credential Share Button",
    value: 1, // Optional numeric value
    nonInteraction: false, // Ensures it counts as an interaction
  });
};

export const handleDigitalCertificateButtonClick = () => {
  ReactGA.event({
    category: "DigitalCertificateClick",
    action: "Digital Certificate Clicked",
    label: "Digital Certificate",
    value: 1,
    nonInteraction: false,
  });
};

export const handleBulkUploadButtonClick = () => {
  ReactGA.event({
    category: "BulkUploadClick",
    action: "Bulk Upload Clicked",
    label: "Bulk Upload",
    value: 1,
    nonInteraction: false,
  });
};

export const handleRequestEligibleClick = () => {
  ReactGA.event({
    category: "RequestBulkUploadEligibleClick",
    action: "Request Eligible Clicked",
    label: "Request Eligible",
    value: 1,
    nonInteraction: false,
  })
}

const formatDate = (date: Date) => {
  const d = date;
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  const year = d.getFullYear();
  return `${year}-${month}-${day}`;
};


export const exportToExcel = (t: (key: string) => string, bulkUpdateList: BulkUpdate[]) => {

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet('EligibleItems');

  //  Title Row 
  worksheet.mergeCells('A1:C1');
  worksheet.getCell('A1').value = `${t('bulkUpload.BulkUploadData')}  - ${formatDate(new Date())}`;
  worksheet.getCell('A1').alignment = { vertical: 'middle', horizontal: 'center' };
  worksheet.getCell('A1').font = { size: 16, bold: true, color: { argb: 'FFFFFFFF' } };
  worksheet.getCell('A1').fill = {
    type: 'pattern',
    pattern: 'solid',
    fgColor: { argb: 'C67B05' },
  };
  worksheet.getCell('A1').border = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };

  // Header Row 
  const headerRow = worksheet.addRow([t('bulkUpload.Name'), t('bulkUpload.ccoId'), t('bulkUpload.EligibleToConnect')]);

  headerRow.eachCell((cell) => {
    cell.font = { bold: true, size: 14 };
    cell.alignment = { vertical: 'middle', horizontal: 'center' };
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },
    };
  });

  // Column Widths 
  worksheet.columns = [
    { key: 'name', width: 25 },
    { key: 'ccoid', width: 15 },
    { key: 'eligible', width: 40 },
  ];

  // Data Rows
  bulkUpdateList.forEach((item) => {
    const eligibleText = item.Iscreated
      ? t(messageMap["Request Sent!"])
      : item.Eligible
        ? t("bulkUpload.Yes")
        : (
          item.Message?.map(msg => t(messageMap[msg] || msg))
          || [t(messageMap["Not Eligible"])]
        ).join(", ");


    const row = worksheet.addRow({
      name: item.Name || '--',
      ccoid: item.CCOID,
      eligible: eligibleText
    });

    row.eachCell((cell, colNumber) => {
      if (colNumber === 2) {

        cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
      } else {

        cell.alignment = { vertical: 'middle', horizontal: 'left', wrapText: true };
      }
      if (colNumber === 3) {
        if (item.Eligible || item.Iscreated) {
          cell.font = { color: { argb: 'FF008000' } };
        } else {
          cell.font = { color: { argb: 'FFFF0000' } };
        }
      }
    });
  });
  // Export
  workbook.xlsx.writeBuffer().then((data) => {
    const blob = new Blob([data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    saveAs(blob, `${t('bulkUpload.BulkUploadData')}_${formatDate(new Date())}.xlsx`);
  });
};











